import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Vehiculos from './pages/Vehiculos';
import Servicios from './pages/Servicios';
import Personal from './pages/Personal';
import Unidades from './pages/Unidades';
import Empresas from './pages/Empresas';
import Aseguradoras from './pages/Aseguradoras';
import TiposServicio from './pages/TiposServicio';
import MetodosPago from './pages/MetodosPago';
import TarifasBase from './pages/TarifasBase';
import Inventario from './pages/Inventario';
import Facturacion from './pages/Facturacion';
import Reportes from './pages/Reportes';
import Asistencias from './pages/Asistencias';
import MisServicios from './pages/MisServicios';
import MiCajaChica from './pages/MiCajaChica';
import CajaChica from './pages/CajaChica';
import Usuarios from './pages/Usuarios';
import LiquidacionPagos from './pages/LiquidacionPagos';
import GestionDocumental from './pages/GestionDocumental';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="vehiculos" element={<Vehiculos />} />
            <Route path="servicios" element={<Servicios />} />
            <Route path="personal" element={<Personal />} />
            <Route path="asistencias" element={<Asistencias />} />
            <Route path="mis-servicios" element={<MisServicios />} />
            <Route path="mi-caja-chica" element={<MiCajaChica />} />
            <Route path="caja-chica" element={<CajaChica />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="unidades" element={<Unidades />} />
            <Route path="empresas" element={<Empresas />} />
            <Route path="aseguradoras" element={<Aseguradoras />} />
            <Route path="tipos-servicio" element={<TiposServicio />} />
            <Route path="metodos-pago" element={<MetodosPago />} />
            <Route path="tarifas-base" element={<TarifasBase />} />
            <Route path="inventario" element={<Inventario />} />
            <Route path="facturacion" element={<Facturacion />} />
            <Route path="liquidacion-pagos" element={<LiquidacionPagos />} />
            <Route path="liquidacion-pagos" element={<LiquidacionPagos />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="gestion-documental" element={<GestionDocumental />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

